<ng-container *ngIf="!loading">

  <div class="relalization-wrapper">

    <div class="legend">
      <div class="legend-item">
        <div class="box violet"></div>
        <span>Реализация</span>
      </div>
      <div class="legend-item">
        <div class="box green"></div>
        <span>Введено в экслупатицию</span>
      </div>
    </div>

    <div class="spots">
      <div class="spot" *ngFor="let spot of spots; let i = index">
        <div class="spot__inner" (click)="openSpot(i)" [ngClass]="spotColors[i]" *ngIf="spot.docs?.length > 0"> 
          <div class="item pie">
            <app-pie-chart-2 *ngIf="spot?.realisationPercent != 0 && spot?.realisationPercent != 100" [centerText]="spot?.realisationPercent"></app-pie-chart-2>
          </div>
          <div class="item number w-150">
            <div class="title">Пятно {{spot.number}}</div>
          </div>
          <div class="item w-150">
            <div class="title">Всего квартир {{spot.apartment_number | numberWithSpaces}}</div>
          </div>
          <div class="item w-150">
            <div class="title">Остаток квартир {{spot.residueFlatCount | numberWithSpaces}}</div>
          </div>
          <div class="item f-1">
            <div class="title">Общая площадь, кв.м. {{spot.totalFlatArea | numberWithSpaces}}</div>
          </div>
          <div class="item f-1">
            <div class="title">Общая стоимость, в тг. {{spot.totalFlatAmount | numberWithSpaces}}</div>
          </div>
        </div>
        <div class="spot-info" *ngIf="spot.isOpen">
          <app-toogle-obj [spotId]="selectedSpotId"></app-toogle-obj>
        </div>
      </div>
    </div>

  </div>
</ng-container>

<ng-container *ngIf="loading">
  <div class="loading"></div>
</ng-container>